module.exports = __webpack_public_path__ + "static/media/snow-tire-installation.01371699.svg";